<template>
    <div>
        <div class="col-md-8 col-sm-12 container">
            <div class="spacer" data-pgc="spacer"></div>
            <h1 class="h2">{{technique.title}}</h1>

            <div :style="{'background-image':`url(${technique.thumbnail})`}" style="width: 100%;height: 0;padding-bottom: 50%;background-size: contain;background-repeat: no-repeat;background-position: center;"></div>

            <article class="lead mt-3" v-html="technique.description">
            </article>
            <Techniques />
        </div>
        <Contact />
    </div>
</template>

<script>
import Contact from '@/components/Contact'
import Techniques from '@/components/Techniques'
export default {
    components:{
        Contact,
        Techniques
    },

    props:{
        id:{
            type: String,
            required: true
        },
    },
    computed:{
        technique(){
            return this.$store.state.technique.currentTechnique
        }
    },
    watch:{
        id(current, old){
            if(current != old){
                this.$store.dispatch('technique/getTechnique', this.id)
            }
        }
    },
    created(){
        this.$store.dispatch('technique/getTechnique', this.id)
    },
    destroyed(){
        this.$store.commit('technique/setCurrentTechnique', [])
    }
}

</script>